/**
 * SsoConnectingStatus — loading + popup-blocked fallback (ADR-0330 R-2 / R-3).
 */

export interface SsoConnectingStatusProps {
  readonly phase: 'idle' | 'opening' | 'blocked';
  readonly fallbackHref: string | null;
  readonly onContinueWithOAuth?: () => void;
}

export function SsoConnectingStatus({
  phase,
  fallbackHref,
  onContinueWithOAuth,
}: SsoConnectingStatusProps): JSX.Element | null {
  if (phase === 'idle') return null;

  if (phase === 'opening') {
    return (
      <p
        role="status"
        aria-live="polite"
        data-testid="sso-connecting-status"
        className="mt-2 text-xs text-jtk-secondary"
      >
        Connecting to Jubit… finish sign-in in the popup.
      </p>
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="sso-popup-fallback"
      className="mt-2 flex max-w-xs flex-col items-center gap-2 text-xs text-jtk-secondary"
    >
      <p>Pop-up blocked. Open sign-in to continue without leaving this page.</p>
      {fallbackHref ? (
        <a
          href={fallbackHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sso-popup-fallback-open"
          className="inline-flex items-center rounded-full bg-jub-tile px-3 py-1 text-xs font-semibold text-neutral-900"
        >
          Open sign-in
        </a>
      ) : null}
      {onContinueWithOAuth ? (
        <button
          type="button"
          data-testid="sso-popup-fallback-oauth"
          onClick={onContinueWithOAuth}
          className="text-xs underline underline-offset-2"
        >
          Continue with Google instead
        </button>
      ) : null}
    </div>
  );
}
